module.exports = __webpack_public_path__ + "img/info.88e470ea.svg";